import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import { MultiBackend, MouseTransition, TouchTransition } from 'react-dnd-multi-backend';

/**
 * Shared react-dnd backend configuration for ALL React calendar views
 * (Month V2 today; Week / Resource / Dispatch inherit it as they migrate).
 *
 * Why multi-backend: the HTML5 backend ignores touch events, so on tablet /
 * phone an event chip could not be dragged. `react-dnd-multi-backend` runs the
 * HTML5 backend for mouse pointers and switches to the Touch backend on a touch
 * start — giving Month V2 the same touch-move capability the legacy Day View
 * has (`calendar/calendar-grid/calendar.grid.js`). The existing `useDrag` /
 * `useDrop` logic is untouched; only the backend changes.
 *
 * Usage:
 *   import { MultiBackend, CALENDAR_DND_OPTIONS } from '.../calendarDndBackend.js';
 *   <DndProvider backend={MultiBackend} options={CALENDAR_DND_OPTIONS}>…</DndProvider>
 */
export const CALENDAR_DND_OPTIONS = {
	backends: [
		{
			id: 'html5',
			backend: HTML5Backend,
			transition: MouseTransition
		},
		{
			id: 'touch',
			backend: TouchBackend,
			options: {
				// Long-press before a drag begins so a quick swipe scrolls the page
				// instead of grabbing an event (drag-vs-scroll disambiguation).
				delayTouchStart: 200,
				// HTML5 backend owns the mouse; the touch backend must not also
				// synthesize mouse events or the two would double-fire.
				enableMouseEvents: false,
				// Allow the browser to scroll while the long-press timer is pending.
				ignoreContextMenu: true
			},
			preview: true,
			transition: TouchTransition
		}
	]
};

export { MultiBackend };
